import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { getStorageLocationsPageParamsSchema } from 'src/pages/storage/locations-new/overview/schema';

export function useStorageLocationsPageParams() {
  return usePageParamsFromSchema(getStorageLocationsPageParamsSchema(), {
    filters: {
      locationName: { label: 'Location Name' },
      locationBusinessId: { label: 'Location ID' },
      ssoOrganisationId: { label: 'SSO' },
      marketAreaId: { label: 'Market Area' },
      ownLocations: { label: 'Quick Filter' },
    },
  });
}

export type StorageLocationsPageParams = ReturnType<
  typeof useStorageLocationsPageParams
>;
